import React, { useState, useEffect } from 'react'
import { Box, Button, Divider, Grid, TextField, IconButton, FormControl, MenuItem, Modal } from '@mui/material'
import { useCreateCardDetailContext } from '../../../CreatecardDetailContext';
// import { CgColorPicker } from "react-icons/cg";
// import "react-color-palette/lib/css/styles.css";
import InfoIcon from '@mui/icons-material/Info';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// import { ColorExtractor } from "react-color-extractor";
import upload_cloud from "../../../../Assets/img/upload-to-cloud.svg"
import axios from 'axios';
import { extractColors } from 'extract-colors'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as TickIcon } from "../../../../Assets/img/icons/tick-shape.svg";
import { useQuantityContext } from '../../../QuantityContext';
import LayoutOption from '../../../Utilities/LayoutOption';
import PreviewCard from './CreatePreview';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import { getAllCardDetailsReducer, getAllCardInfoReducer } from '../../../../Redux/Reducers/CardReducer';
import { useDispatch } from 'react-redux';

const CardDesignerPaid = ({ handleSuccess, handleFailure }) => {
    const { cardDetails, CardStyles, updateCardStyles } = useCreateCardDetailContext();
    const [SaveEnable, setSaveEnable] = useState(false);
    const [initialCardStyles, setInitialCardStyles] = useState({});
    const { setisNavigationBlocked, handleInfo } = useQuantityContext();
    const objectId = localStorage.getItem("objectId");
    // 
    // const { Designation } = cardDetails;

    const dispatch = useDispatch();
    useEffect(() => {
        setInitialCardStyles(CardStyles);
    }, []);

    useEffect(() => {
        setSaveEnable(JSON.stringify(initialCardStyles) !== JSON.stringify(CardStyles));
        setisNavigationBlocked(JSON.stringify(initialCardStyles) !== JSON.stringify(CardStyles));
    }, [CardStyles, initialCardStyles]);

    const handleInputChange = (fieldName) => (event) => {
        const newValue = event.target.value;
        updateCardStyles({ [fieldName]: newValue });
    };

    const apiKey = process.env.REACT_APP_API_KEY
    const headers = {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${objectId}`

    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (CardStyles?.CardType?.startsWith("Customize_") && (CardStyles.CardName === '' || CardStyles.CardName === null)) {
            handleInfo("CardName should not be Empty, Fill it in Personal Details");
            return;
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/card-styles`, CardStyles,
                // /card/cardNewStyles
                { headers: headers }
            );
            console.log('Response from backend:', response.data);
            setInitialCardStyles(CardStyles);
            dispatch(getAllCardDetailsReducer());

            dispatch(getAllCardInfoReducer());
            handleSuccess();
        } catch (error) {
            console.error('Error submitting cardStyles:', error);
            handleFailure();
        }
    };

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorElLayout, setAnchorElLayout] = React.useState(null);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const handleLayoutPopoverOpen = (event) => {
        setAnchorElLayout(event.currentTarget);
    };

    const handleLayoutPopoverClose = () => {
        setAnchorElLayout(null);
    };

    const [openPopoverCustom, setOpenPopoverCustom] = useState(false);
    const [anchorElPopoverCustom, setAnchorElPopoverCustom] = useState(null);

    const handlePopoverOpenCustom = (event) => {
        setAnchorElPopoverCustom(event.currentTarget);
        setOpenPopoverCustom(true);
    };

    const handlePopoverCloseCustom = () => {
        setAnchorElPopoverCustom(null);
        setOpenPopoverCustom(false);
    };


    const open = Boolean(anchorEl);
    const openLayout = Boolean(anchorElLayout);
    const [colors, setColors] = useState([]);
    const [imageSrc, setImageSrc] = useState(null);
    const [generateClick, setgenerateClick] = useState(false);

    const handleGenerateColor = () => {


        setgenerateClick(true);
        if (imageSrc) {

            extractColors(imageSrc)
                .then(colors => {
                    console.log(colors[0]);
                    const primaryColorHex = colors[0]?.hex || ''; // Extracting the hexadecimal color value
                    const colorSecondary = colors[1]?.hex || '';
                    const colorTitle = colors[2]?.hex || '';

                    updateCardStyles({ colorPrimary: primaryColorHex });
                    updateCardStyles({ colorSecondary: colorSecondary });
                    updateCardStyles({ colorTitle: colorTitle });
                    setColors([primaryColorHex, colorSecondary, colorTitle]);
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }

    const defaultColors = ["#00000099", "#000000DE", "#00000099"];

    const RenderbackgroundColors = () => {
        const displayColors = colors?.length > 0 ? colors : defaultColors;
        const handleColorClick = (color) => {
            navigator.clipboard.writeText(color);
        };

        return (
            <div className="default-colors-container">
                {displayColors.map((color, id) => (
                    <div key={id} className="default-color-item Brand-colors-outer">
                        <span className="color-code">{color}</span>
                        <div
                            className="Brand-colors"
                            style={{
                                backgroundColor: color,
                            }}
                            onClick={() => handleColorClick(color)}
                        />
                    </div>
                ))}
            </div>
        );
    };
    const [copiedSuccess, setCopiedSuccess] = useState(false);

    const renderSwatches = () => {
        const displayColors = colors?.length > 0 ? colors : defaultColors;
        const handleColorClick = (color) => {
            navigator.clipboard.writeText(color);
            setCopiedSuccess(true); // Show success message

            // Hide success message after 30 seconds
            setTimeout(() => {
                setCopiedSuccess(false);
            }, 30000);
        };

        return displayColors.map((color, id) => (
            <div
                key={id}
                style={{
                    backgroundColor: color,
                    width: 16,
                    height: 16,
                    cursor: 'pointer', // Add cursor pointer to indicate it's clickable
                }}
                onClick={() => handleColorClick(color)} // Call the event handler when clicked
            />
        ));
    };
    // const getColors = (detectedColorCodes) => {
    //   setColors(detectedColorCodes);
    // };

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            setImageSrc(event.target.result);
        };
        reader.readAsDataURL(file);
        setgenerateClick(false);
    };

    const layoutOptions = (CardStyles.CardType === 'Personal' || CardStyles.CardType === 'Customize_Personal') ? ['2', '4', '6', '8'] : ['1', '3', '5', '7']; // To segregate personal and professional card layouts

    const [layoutStyle, setLayoutStyle] = useState(CardStyles.CardType === 'Personal' ? '2' : '1');
    const [openLayoutsModal, setOpenLayoutsModal] = useState(false);

    const handleLayoutSelection = (layoutNumber) => {
        setLayoutStyle(layoutNumber)
        updateCardStyles({ layoutStyle: layoutNumber });
        // console.log("layoutStyle: ", CardStyles.layoutStyle);
    };

    // const [availableHeight1, PreviewCardRef] = useAvailableHeight(148);

    const handleLayoutsModalClose = () => {
        setOpenLayoutsModal(false);
    }

    const [openBoxes, setOpenBoxes] = useState({
        professional: false,
        doctor: false,
        advocate: false,
        charteredAccountants: false,
        it: false,
        bank: false,
        hr: false,
        companySecretary: false,
        freelancers: false,
    });

    const handleToggle = (box) => {
        setOpenBoxes((prevState) => ({
            ...prevState,
            [box]: !prevState[box],
        }));
    };

    const categories = [
        { key: 'professional', label: 'Professional' },
        { key: 'doctor', label: 'Doctor' },
        { key: 'advocate', label: 'Advocate' },
        { key: 'charteredAccountants', label: 'Chartered Accountants' },
        { key: 'itech', label: 'IT' },
        { key: 'bank', label: 'Bank' },
        { key: 'hr', label: 'Human Resources' },
        { key: 'companySecretary', label: 'Company Secretary' },
        { key: 'freelancers', label: 'Freelancers' },
    ];

    const additionalLayouts = {
        professional: layoutOptions,
        charteredAccountants: ['ca1', 'ca2'],
        hr: ['hr1', 'hr2'],
        bank: ['bk1', 'bk2'],
        freelancers: ['fl1', 'fl2'],
        companySecretary: ['cs1', 'cs2'],
        itech: ['it1', 'it2'],
        advocate: ['adv1', 'adv2'],
        doctor: ['dr1', 'dr2'],
        // Add more categories and their layouts as needed
    };

    const [isPaid, setIsPaid] = useState(true);

    return (
        <div>
            {/* <Box className='my-4 card-info-box ' sx={{ border: "1px solid #17b200", backgroundColor: "white", borderRadius: 2, paddingTop: "16px" }}> */}
            <div className='Scroll-behaviour'>
                <div className="px-3">
                    <div className="card-edit-info-heading" style={{ position: "relative" }}>
                        <h5>Customize Card (Paid)</h5>
                        <span>Customize your card typography and colors.</span>
                        <Button variant='contained' sx={{ backgroundColor: "#0044C6", position: "absolute", top: "4px", right: "8px" }} onClick={() => setIsPaid(!isPaid)}>Go to {isPaid === true ? 'Free' : 'Paid'}</Button>
                    </div>

                    {isPaid &&
                        <div className="my-4 user-details-container">
                            <h5>Card Layout</h5>
                            <Grid className='mt-2 layout-grid' container spacing={2}>
                                {layoutOptions.map((layoutNumber) => (
                                    <Grid item xs={3} key={layoutNumber}>
                                        <LayoutOption
                                            optionNumber={layoutNumber}
                                            handleSelect={handleLayoutSelection}
                                            isSelected={layoutStyle === layoutNumber}
                                            useCardContext={useCreateCardDetailContext}
                                        />
                                    </Grid>
                                ))}
                                {(CardStyles.CardType === 'Professional' || CardStyles.CardType === 'Customize_Professional') &&
                                    <Grid item xs={3}>
                                        <Button className='mt-2' variant='contained' onClick={() => setOpenLayoutsModal(true)} sx={{ backgroundColor: "#0044C6" }}> Show More</Button>
                                    </Grid>}
                            </Grid>
                        </div>
                    }

                    <div className="my-4 user-details-container">
                        <h5>Typography</h5>

                        <Grid className='mt-2' container spacing={2}>
                            {/* First Column */}
                            <Grid item xs={6}>
                                <Grid container direction="column" spacing={2}>
                                    <Grid item>
                                        <FormControl fullWidth>
                                            <TextField
                                                name="Fonts"
                                                label="Fonts"
                                                required
                                                select
                                                value={CardStyles?.font || 'Lato'}
                                                onChange={handleInputChange('font')}
                                                InputLabelProps={{ required: false }}
                                            >
                                                <MenuItem value="Montserrat">Montserrat</MenuItem>
                                                <MenuItem value="Lato">Lato</MenuItem>
                                                <MenuItem value="Open Sans, sans-serif">Open Sans</MenuItem>
                                                <MenuItem value="Georgia, serif">Georgia</MenuItem>
                                                <MenuItem value="Oswald">Oswald</MenuItem>
                                                <MenuItem value="Arial">Arial</MenuItem>
                                                <MenuItem value="Poppins">Poppins</MenuItem>
                                                <MenuItem value="Ubuntu">Ubuntu</MenuItem>
                                                <MenuItem value="Source Sans">Source Sans</MenuItem>
                                            </TextField>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {/* Second Column */}
                            <Grid item xs={6}>
                                <Grid container direction="column" spacing={2}>
                                    <Grid item>
                                        <FormControl fullWidth>
                                            <TextField
                                                name="Font Styles"
                                                label="Font Styles"
                                                required
                                                select
                                                value={CardStyles?.style || 'Regular'}
                                                onChange={handleInputChange('style')}
                                                InputLabelProps={{ required: false }}
                                            >
                                                <MenuItem value="Light">Light</MenuItem>
                                                <MenuItem value="Regular">Regular</MenuItem>
                                                <MenuItem value="Medium">Medium</MenuItem>
                                                <MenuItem value="Semi Bold">Semi Bold</MenuItem>
                                                <MenuItem value="Bold">Bold</MenuItem>
                                            </TextField>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>

                    <Divider color='#0000001F' />

                    <div className="my-4 user-details-container">
                        <h5>Text Color</h5>
                        <Grid className='mt-2' container spacing={2}>
                            <Grid item md={6} lg={4} className='m-0 pt-0'>
                                <p className='mt-0'>Primary Color</p>
                                <Grid container direction="column" spacing={2}>
                                    <Grid container alignItems="center" justifyItems="center">
                                        <Grid item xs={1}></Grid>
                                        <Grid item xs={10}>
                                            <TextField
                                                value={CardStyles?.colorPrimary || '#000000'}
                                                onChange={(e) => {
                                                    handleInputChange('colorPrimary')(e);
                                                }}
                                                className='color-picker-field card-designer'
                                                fullWidth
                                                InputProps={{
                                                    endAdornment:
                                                        <div className="icon-color-picker card-designer" style={{ backgroundColor: CardStyles?.colorPrimary || "000000DE" }}>
                                                            <input
                                                                type='color'
                                                                className="color-picker-input"
                                                                onChange={(e) => {
                                                                    handleInputChange('colorPrimary')(e);
                                                                }}
                                                                defaultValue={CardStyles?.colorPrimary || '#000000'}
                                                            />
                                                        </div>
                                                }}
                                            />
                                        </Grid>
                                        {/* <Grid item xs={3}>
                                            <div className="icon-color-picker d-flex align-items-center justify-content-center">
                                                <label className="color-picker-label">
                                                    <CgColorPicker className="color-picker-icon" />
                                                    <input
                                                        type='color'
                                                        className="color-picker-input"
                                                        onChange={(e) => {
                                                            handleInputChange('colorPrimary')(e);
                                                        }}
                                                    />
                                                </label>
                                            </div>
                                        </Grid> */}
                                    </Grid>
                                    <p className='color-picker-caption card-designer'>Name Text</p>
                                </Grid>
                            </Grid>

                            <Grid item md={6} lg={4} className='m-0 pt-0'>
                                <p className='mt-0'>Secondary Color</p>
                                <Grid container direction="column" spacing={2}>
                                    <Grid container alignItems="center" justifyItems="center">
                                        <Grid item xs={1}></Grid>
                                        <Grid item xs={10}>
                                            <TextField
                                                value={CardStyles?.colorSecondary || '#000000'}
                                                onChange={(e) => handleInputChange('colorSecondary')(e)} // Update selectedColor state when the text field value changes
                                                fullWidth
                                                className='color-picker-field card-designer'
                                                InputProps={{
                                                    endAdornment:
                                                        <div className="icon-color-picker card-designer" style={{ backgroundColor: CardStyles?.colorSecondary || "#00000099" }}>
                                                            <input
                                                                type='color'
                                                                className="color-picker-input"
                                                                onChange={(e) => {
                                                                    handleInputChange('colorSecondary')(e);
                                                                }}
                                                                defaultValue={CardStyles?.colorSecondary || '#000000'}
                                                            />
                                                        </div>
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <p className='color-picker-caption card-designer'>Other Text</p>
                                </Grid>
                            </Grid>

                            <Grid item md={6} lg={4} className='m-0 pt-0'>
                                <p className='mt-0'>Title Color</p>
                                <Grid container className='' direction="column" spacing={2}>
                                    <Grid container alignItems="center" justifyItems="center">
                                        <Grid item xs={1}></Grid>
                                        <Grid item xs={10}>
                                            <TextField
                                                value={CardStyles?.colorTitle || '#000000'}
                                                onChange={(e) => {
                                                    handleInputChange('colorTitle')(e);
                                                }}
                                                fullWidth
                                                className='color-picker-field card-designer'
                                                InputProps={{
                                                    endAdornment:
                                                        <div className="icon-color-picker card-designer" style={{ backgroundColor: CardStyles?.colorTitle || "#000000DE" }}>
                                                            <input
                                                                type='color'
                                                                className="color-picker-input"
                                                                onChange={(e) => {
                                                                    handleInputChange('colorTitle')(e);
                                                                }}
                                                                defaultValue={CardStyles?.colorTitle || '#000000'}
                                                            />
                                                        </div>
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <p className='color-picker-caption card-designer'>Title Color</p>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>

                    <Divider color='#0000001F' />

                    <div className="my-4 text-left">
                        <div className='d-flex align-items-center'>
                            <h5 className='mb-0'>AI-Based Brand Logo Color</h5>
                            <Typography
                                aria-owns={open ? 'mouse-over-popover' : undefined}
                                aria-haspopup="true"
                                onMouseEnter={handlePopoverOpen}
                                onMouseLeave={handlePopoverClose}
                            >
                                <IconButton className="info-icon"> <InfoIcon /></IconButton>
                            </Typography>
                            <Popover
                                id="mouse-over-popover"
                                sx={{
                                    pointerEvents: 'none',
                                }}
                                open={open}
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'bottom'
                                }}
                                onClose={handlePopoverClose}
                                disableRestoreFocus
                            >
                                <Typography className='pop-content card-designer'>
                                    <p className='pop-content card-designer'>
                                        Upload your logo and we'll generate color <br /> schemes based on it and can apply it to Texts.
                                    </p>
                                </Typography>
                            </Popover>
                        </div>

                        <Grid className='mt-2' container spacing={2}>
                            <Grid className='mt-0 pt-0' item xs={3}>
                                <div className='dashed-border d-flex align-items-center'>
                                    {!imageSrc &&
                                        <>
                                            <img src={upload_cloud} alt="cloud" />
                                            <label htmlFor="file-input" className="custom-upload-button">
                                                Upload File
                                            </label>
                                            <input
                                                id="file-input"
                                                type="file"
                                                accept="image/*"
                                                onChange={handleImageUpload}
                                                style={{ display: "none" }}
                                            />
                                        </>
                                    }
                                    {imageSrc && <>
                                        <img
                                            src={imageSrc}
                                            style={{ width: '100%', height: '100%' }}
                                            alt="sample"
                                        />
                                    </>
                                    }
                                </div>
                            </Grid>
                            <Grid className='mt-0 pt-0' item xs={5}>
                                {/* <button className='Generate-colors' onClick={handleGenerateColor}>Generate Colors</button> */}
                                <Button className='mb-1' variant='contained' sx={{ backgroundColor: "#0044C6", padding: "4px 12px" }} onClick={handleGenerateColor} disabled={!imageSrc}>Generate Colors</Button>

                                <div className='mt-2 Colors-display-border '>
                                    {renderSwatches()}
                                </div>
                            </Grid>
                        </Grid>
                    </div>

                    <Divider color='#0000001F' />

                    <div className="my-4 user-details-container">
                        <div className="d-flex align-items-center">
                            <h5 className='mb-0'>Layout Color</h5>
                            <Typography
                                aria-owns={openLayout ? 'mouse-over-popover' : undefined}
                                aria-haspopup="true"
                                onMouseEnter={handleLayoutPopoverOpen}
                                onMouseLeave={handleLayoutPopoverClose}
                            >
                                <IconButton className="info-icon"> <InfoIcon /></IconButton>
                            </Typography>
                            <Popover
                                id="mouse-over-popover"
                                sx={{
                                    pointerEvents: 'none',
                                }}
                                open={openLayout}
                                anchorEl={anchorElLayout}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'bottom'
                                }}
                                onClose={handleLayoutPopoverClose}
                                disableRestoreFocus
                            >
                                <Typography className='pop-content card-designer'>
                                    <p className='pop-content card-designer'>
                                        Indicates the shapes and elements <br /> like lines and icon background color.
                                    </p></Typography>
                            </Popover>
                        </div>
                        <Grid className='mt-2' container spacing={2}>
                            <Grid item xs={4} className='m-0 pt-0'>
                                <p className='mt-0 mb-2'>Element Color</p>
                                <Grid className='mt-1' container direction="column" spacing={2}>
                                    <Grid container alignItems="center" justifyItems="center">
                                        <Grid item xs={1}></Grid>
                                        <Grid item xs={10}>
                                            <TextField
                                                value={CardStyles?.colorLayout || '#0044C6'}
                                                onChange={(e) => {
                                                    handleInputChange('colorLayout')(e);
                                                }}
                                                className='color-picker-field card-designer'
                                                fullWidth
                                                InputProps={{
                                                    endAdornment:
                                                        <div className="icon-color-picker card-designer" style={{ backgroundColor: CardStyles?.colorLayout || '#0044C6' }}>
                                                            <input
                                                                type='color'
                                                                className="color-picker-input"
                                                                onChange={(e) => {
                                                                    handleInputChange('colorLayout')(e);
                                                                }}
                                                                defaultValue={CardStyles?.colorLayout || '#0044C6'}
                                                            />
                                                        </div>
                                                }}
                                            />
                                        </Grid>
                                        {/* <Grid item xs={3}>
                                            <div className="icon-color-picker d-flex align-items-center justify-content-center">
                                                <label className="color-picker-label">
                                                    <CgColorPicker className="color-picker-icon" />
                                                    <input
                                                        type='color'
                                                        className="color-picker-input"
                                                        onChange={(e) => {
                                                            handleInputChange('colorPrimary')(e);
                                                        }}
                                                    />
                                                </label>
                                            </div>
                                        </Grid> */}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>

                    <Divider color='#0000001F' />

                    <div className="my-4 user-details-container">
                        <div className="d-flex align-items-center">
                            <h5 className='mb-0'>Card Background Color</h5>
                            <Typography
                                aria-owns={openPopoverCustom ? 'mouse-over-popover-custom' : undefined}
                                aria-haspopup="true"
                                onMouseEnter={handlePopoverOpenCustom}
                                onMouseLeave={handlePopoverCloseCustom}
                            >
                                <IconButton className="info-icon"> <InfoIcon /></IconButton>
                            </Typography>
                            <Popover
                                id="mouse-over-popover-custom"
                                sx={{
                                    pointerEvents: 'none',
                                }}
                                open={openPopoverCustom}
                                anchorEl={anchorElPopoverCustom}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'bottom'
                                }}
                                onClose={handlePopoverCloseCustom}
                                disableRestoreFocus
                            >
                                <Typography className='pop-content card-designer'>
                                    <p className='pop-content card-designer'>
                                        Prefer lighter color for Dark Bg,<br />
                                        Dark color for Light bg
                                    </p>
                                </Typography>
                            </Popover>
                        </div>
                        <Grid className='mt-2' container spacing={2}>
                            <Grid item xs={4} className='m-0 pt-0'>
                                <Grid className='mt-1' container direction="column" spacing={2}>
                                    <Grid container alignItems="center" justifyItems="center">
                                        <Grid item xs={1}></Grid>
                                        <Grid item xs={10}>
                                            <TextField
                                                value={CardStyles?.bgColor || '#ffffff'}
                                                onChange={(e) => {
                                                    handleInputChange('bgColor')(e);
                                                }}
                                                className='color-picker-field card-designer'
                                                fullWidth
                                                InputProps={{
                                                    endAdornment:
                                                        <div className="icon-color-picker card-designer" style={{ backgroundColor: CardStyles?.bgColor || '#ffffff' }}>
                                                            <input
                                                                type='color'
                                                                className="color-picker-input"
                                                                onChange={(e) => {
                                                                    handleInputChange('bgColor')(e);
                                                                }}
                                                                defaultValue={CardStyles?.bgColor || '#ffffff'}
                                                            />
                                                        </div>
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                    </div>
                </div>
                <div className="save-bottom" style={{ textAlign: "right", backgroundColor: "#0044C614", padding: "12px" }}>
                    <Button variant='contained' onClick={handleSubmit} disabled={!SaveEnable} sx={{ backgroundColor: "#0044C6" }}>Save</Button>
                </div>
                <ToastContainer toastClassName="email-toast-success" />

                <Modal open={openLayoutsModal} onClose={handleLayoutsModalClose}>
                    <Box className='layouts-modal-box' sx={{ position: 'absolute', top: '15%', left: '15%', width: "auto", bgcolor: 'background.paper', boxShadow: "0px 12px 24px 0px #919EAB1F, 0px 0px 2px 0px #919EAB33", borderRadius: 2, p: 3, minWidth: "70%", maxHeight: "80%", /*overflowY: "scroll", scrollbarWidth: "thin"*/ }}>
                        <div className="modal-heading">
                            <h5>View More Cards Templates</h5>
                            <span>Choose Cards templates based on the categories</span>
                            <span className='span-center-align file-attach-icon-container'>
                                <IconButton color="rgb(0, 0, 0, 0.54)" onClick={handleLayoutsModalClose}>
                                    <CloseRoundedIcon />
                                </IconButton></span>
                        </div>
                        <div className="row gx-0">
                            <div className="col-6 col-xl-7">
                                <div className='me-4 layout-categories-container'>
                                    {categories
                                        // .filter((category) => category.label === 'Professional' || category.label === Designation)
                                        .map((category) => (
                                            <React.Fragment key={category.key}>
                                                <Box className={`my-3 genz-prof-fields ${openBoxes[category.key] ? 'opened' : ''}`}>
                                                    <span>{category.label}</span>
                                                    <IconButton color="inherit" onClick={() => handleToggle(category.key)} disableRipple>
                                                        {openBoxes[category.key] ? (
                                                            <RemoveCircleOutlineRoundedIcon />
                                                        ) : (
                                                            <AddCircleOutlineRoundedIcon />
                                                        )}
                                                    </IconButton>
                                                </Box>
                                                {openBoxes[category.key] && (
                                                    <div className="expanded-content">
                                                        <Grid className='mt-2 layout-grid' container spacing={2}>
                                                            {additionalLayouts[category.key].map((layoutIdentifier) => (
                                                                <Grid item md={4} xl={3} key={layoutIdentifier}>
                                                                    <LayoutOption
                                                                        optionNumber={layoutIdentifier}
                                                                        handleSelect={handleLayoutSelection}
                                                                        isSelected={layoutStyle === layoutIdentifier}
                                                                        category={category.key === 'professional' ? 'regular' : 'prof'}
                                                                        useCardContext={useCreateCardDetailContext}
                                                                    />
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    </div>
                                                )}
                                            </React.Fragment>
                                        ))}
                                </div>
                            </div>
                            <div className="col-6 col-xl-5 d-flex justify-content-center">
                                <Box className="layout-preview-container">
                                    <PreviewCard isInsideModal={true} />
                                </Box>
                            </div>
                        </div>
                    </Box>
                </Modal>
            </div>
            {/* </Box > */}
        </div >

    )
}

export default CardDesignerPaid